import backend from '@common/backend';
import { Tutor } from '@common/types/tutors';

export const groupFromBE = (group: any) =>
	group
		? {
				...group,
				service: group.service_id,
				service_template: group.service_template_id,
			}
		: group;

const BASE = '/teachers';
export interface IGetTeachersQuery {
	search?: string;
	service_id?: number;
	page?: number;
	limit?: number;
	is_tutor?: 0 | 1;
	is_online?: 0 | 1;
	is_offline?: 0 | 1;
}

export const getTeachers = async (query: IGetTeachersQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const getTutors = async (query: IGetTeachersQuery): Promise<Tutor[]> =>
	backend.get(`${BASE}/tutors`, {
		params: query,
	});

export const getTeacherUnreviewedLessons = async (query: { service_id: number }) =>
	backend.get(`${BASE}/unreviewedLessons`, {
		params: query,
	});

export const createTeacher = async (data: any) => backend.post(`${BASE}`, data);

export const getTeacher = async (id: number) => backend.get(`${BASE}/${id}`);

export const removeTeacher = async (id: number) => backend.delete(`${BASE}/${id}`);

export const saveTeacher = async (id: number, { programs, ...data }: any) =>
	backend.post(`${BASE}/${id}`, {
		...data,
		...(data.is_tutor !== undefined && { is_tutor: data.is_tutor ? 1 : 0 }),
		...(data.is_online !== undefined && { is_online: data.is_online ? 1 : 0 }),
		...(data.is_offline !== undefined && { is_offline: data.is_offline ? 1 : 0 }),
		...(programs !== undefined && {
			program_ids: programs.map((program: { id: number }) => program.id),
		}),
	});

export const getTeacherGroups = async (query: any) =>
	backend
		.get(`${BASE}/groups`, {
			params: query,
		})
		.then((groups: any) => groups.map(groupFromBE));
